export default {
  maxFileSize: 20,
};
